import { onResponse } from 'hub-http/middlewares/core';
import { showAlert } from '../../components/common/GeneralAlert';
import { STATUS_CODES } from '../../constants/Http';
import { WARNING_ALERT_SHOWING_TIMEOUT } from '../../constants/timeouts';
import { isKnownError } from '../errors';
const skipIntervalRefreshMiddleware = options => onResponse(response => {
  if (response.isErrorHandled || response.options.ignoreErrors) return response;
  const setSkipRefresh = response.options.setSkipRefresh;
  if (typeof setSkipRefresh === 'function' && (response.status > STATUS_CODES.BAD_REQUEST || response.status === STATUS_CODES.NETWORKERROR) && !isKnownError(response.responseText, response.status)) {
    setSkipRefresh();
    showAlert({
      title: 'errors.refreshError.title',
      message: 'errors.refreshError.description',
      type: 'warning',
      timeout: WARNING_ALERT_SHOWING_TIMEOUT,
      id: 'interval-alert'
    });
    response.isErrorHandled = true;
  }
  return response;
})(options);
export default skipIntervalRefreshMiddleware;